// 21.2.5.3 get RegExp.prototype.flags()
if(require(28) && /./g.flags != 'g')require(67).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: require(36)
});